'use strict';

/**
 * @ngdoc directive
 * @name v-tv-package-multiplex-modal
 *
 * @description
 * #directive
 * Display modal dialog for multiplex elements
 *
 * @template:'<div data-ng-if="$ctrl.mplex.description" class="description" data-ng-bind-html="$ctrl.mplex.description"></div><div data-ng-if="$ctrl.mplex.note" class="note" data-ng-bind-html="$ctrl.mplex.note"></div><p data-ng-if="$ctrl.mplex.isChannelGroup" class="note" data-translate="CHANNELS.MULTIPLEX_AS_SINGLE" data-translate-values="{ name: $ctrl.mplex.label }"></p><ul class="channels-list clearfix"><li class="channel-img pull-left" data-ng-class="{ \'mplex-many\': mplex.isChannelGroup, \'mplex-selected\': $ctrl.isSelected, \'mplex-invalid\': $ctrl.isInvalid, \'search-match\': $ctrl.mplex.vm && $ctrl.mplex.vm.markedElems[channel.id] }" data-ng-repeat="channel in $ctrl.mplex.channels"><div class="channel-logo"><img data-ng-src="{{channel.logoUrl}}"></div><v-modal data-size="medium" data-template-data="$ctrl.detailsData" data-template-channel-id="channel.id" data-template-url="mplex-channel-details-dialog" data-extra-class="v-residential-theme" data-append-to="v-tv-package .v-tv-package" data-ng-click="$ctrl.showChannelDetailModal(channel)"><button type="button" class="mplex-detail-btn" data-translate="PACKAGES.DETAIL_BUTTON_CAPTION"></button></v-modal></li></ul>'
 * @param {object} origmplex The mplex element to show in dialog
 */

angular.module('v-tv-package').component('vTvPackageMultiplexModal', {
    bindings: {
        origmplex: '<mplex'
    },
    controller: function controller($scope, TvPackageSelectionStateService) {
        var _this = this;

        var cart = TvPackageSelectionStateService.getActiveCart();

        var initSelection = function initSelection() {
            _this.isSelected = cart.has(_this.origmplex.id);
            _this.isInvalid = !cart.isValid(_this.origmplex.id);
        };

        this.mplex = angular.copy(this.origmplex);

        this.detailsData = {
            mplex: this.mplex,
            selectedChannel: null
        };

        this.setSelectedChannel = function (channel) {
            _this.detailsData.selectedChannel = channel;
        };

        this.showChannelDetailModal = function (channel) {
            _this.setSelectedChannel(channel);
            $scope.$parent.closeThisDialog();
        };

        initSelection();
    },
    template:'<div data-ng-if="$ctrl.mplex.description" class="description" data-ng-bind-html="$ctrl.mplex.description"></div><div data-ng-if="$ctrl.mplex.note" class="note" data-ng-bind-html="$ctrl.mplex.note"></div><p data-ng-if="$ctrl.mplex.isChannelGroup" class="note" data-translate="CHANNELS.MULTIPLEX_AS_SINGLE" data-translate-values="{ name: $ctrl.mplex.label }"></p><ul class="channels-list clearfix"><li class="channel-img pull-left" data-ng-class="{ \'mplex-many\': mplex.isChannelGroup, \'mplex-selected\': $ctrl.isSelected, \'mplex-invalid\': $ctrl.isInvalid, \'search-match\': $ctrl.mplex.vm && $ctrl.mplex.vm.markedElems[channel.id] }" data-ng-repeat="channel in $ctrl.mplex.channels"><div class="channel-logo"><img data-ng-src="{{channel.logoUrl}}"></div><v-modal data-size="medium" data-template-data="$ctrl.detailsData" data-template-channel-id="channel.id" data-template-url="mplex-channel-details-dialog" data-extra-class="v-residential-theme" data-append-to="v-tv-package .v-tv-package" data-ng-click="$ctrl.showChannelDetailModal(channel)"><button type="button" class="mplex-detail-btn" data-translate="PACKAGES.DETAIL_BUTTON_CAPTION"></button></v-modal></li></ul>'
});